// extracted by mini-css-extract-plugin
module.exports = {"reading-time":"ReadingTime_reading-time__HTKMk","reading-time__icon":"ReadingTime_reading-time__icon__SClsV","reading-time__time":"ReadingTime_reading-time__time__guspR"};